export default __webpack_public_path__ + "static/media/dark-edit-icon.5a7d4eea.svg";